import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Mail, CheckCircle, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { API } from '../App';

const NewsletterForm = ({ variant = 'default' }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      toast.error('Por favor, introduce un email válido');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API}/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();
      
      if (response.ok) {
        setSubscribed(true);
        setEmail('');
        toast.success(data.message);
      } else {
        toast.error(data.detail || 'Error al suscribirse');
      }
    } catch (error) {
      toast.error('Error de conexión. Inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  if (subscribed) {
    return (
      <div className={`flex items-center gap-2 ${variant === 'footer' ? 'text-emerald-400' : 'text-green-600'}`}>
        <CheckCircle className="w-5 h-5" />
        <span className="text-sm font-medium">¡Gracias por suscribirte!</span>
      </div>
    );
  }

  // Footer variant - more compact
  if (variant === 'footer') {
    return (
      <form onSubmit={handleSubmit} className="space-y-3" data-testid="newsletter-form-footer">
        <p className="text-slate-300 text-sm">
          Recibe las mejores ofertas de trabajo directamente en tu email.
        </p>
        <div className="flex gap-2">
          <Input
            type="email"
            placeholder="tu@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="bg-slate-800 border-slate-700 text-white placeholder:text-slate-500 flex-1"
            data-testid="newsletter-email-input"
          />
          <Button 
            type="submit" 
            disabled={loading}
            className="bg-red-600 hover:bg-red-700 text-white px-4"
            data-testid="newsletter-submit-btn"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />}
          </Button>
        </div>
      </form>
    );
  }

  // Default variant - for homepage or standalone
  return (
    <div className="bg-gradient-to-r from-red-50 to-red-100 rounded-2xl p-6 md:p-8" data-testid="newsletter-form">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
          <Mail className="w-6 h-6 text-white" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-slate-900">Newsletter JobSuiza</h3>
          <p className="text-slate-600 text-sm">Las mejores ofertas en tu bandeja de entrada</p>
        </div>
      </div>
      
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <Input
          type="email"
          placeholder="Introduce tu email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="flex-1"
          data-testid="newsletter-email-input"
        />
        <Button 
          type="submit" 
          disabled={loading}
          className="bg-red-600 hover:bg-red-700 text-white"
          data-testid="newsletter-submit-btn"
        >
          {loading ? (
            <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Suscribiendo...</>
          ) : (
            <>Suscribirme Gratis</>
          )}
        </Button>
      </form>
      
      <p className="text-xs text-slate-500 mt-3">
        Sin spam. Puedes darte de baja en cualquier momento.
      </p>
    </div>
  );
};

export default NewsletterForm;
